import { observer } from "mobx-react-lite"
import StepsHeader from "./StepsHeader"
import HeaderStep from "./HeaderStep"
import Switch from "./Switch"
import SwitchSelector from "./SwitchSelector"
import SwitchSelectorButton from "./SwitchSelectorButton"
import SimpleSwitch from "./SimpleSwitch"
import InfoBar from "./InfoBar"
import { Button } from "./Button"
import Play from "../icons/Play"

import Select2 from "./Select2"
import FabricCard from "./FabricCard"
import { store } from "../stores/Store"
import SimpleCard from "./SimpleCard"
import { GoldBadge } from "./GoldBadge"
import ConfigurableCard from "./ConfigurableCard"
import { BlankCard } from "./BlankCord"
import React, { useEffect, useRef } from "react"
import SortIcon from "../icons/SortIcon"
import FilterButton from "./FilterButton"
import FiltersFabrics from "./FIltersFabrics"
import SingleMattressIcon from "../icons/SingleMattressIcon"
import DoubleMattressIcon from "../icons/DoubleMattressIcon"
import Collapse from "./Collapse"
import BedIcon from "../icons/BedIcon"
import { BREAKPOINT_SM } from "../stores/constants"
import { publicUrl } from "../utils/url"
import HeightIcon from "../icons/HeightIcon"
import Debugger from "./Debugger"
import OptionModel from "../models/OptionModel"
import { formatCurrency } from "../utils/Currency"
import { SummaryRender } from "../modals/SummaryModal"
import ProductModel from "../stores/ProductModel"
import StepModel from "../models/StepModel"
import { RenderIf } from "./RenderIf"
import { AnimatePresence, motion } from "motion/react"
import Error from "./Error"
import { MATTRESS_HARDNESS_OPTION_ID } from "../models/ProductConfigurationOption"
import { MATTRESS_WITH_BED_DISCOUNT } from "../utils/ConfigurationOptions"
import { Gtm } from "../utils/Gtm"
import { Clarity } from "../utils/Clarity"
import { _t } from "../utils/Lang"



/**
 * 
 * @param {{componentType:"radio_dimensions"|"radio_height", options:OptionModel[]|null, step:StepModel}} param0 
 * @returns 
 */
const ComponentTypeFactory = observer(({ index, step, componentType, options = [], isSubcomponent = false }: { componentType: "radio_dimensions" | "radio_height", options: OptionModel[] | null, step: StepModel }) => {
    switch (componentType) {
        case 'radio_dimensions':

            return <>

                {!isSubcomponent ? <HeaderStep id={step.typeId} index={index} title={step.name} right={null} /> : null}
                {/* dim */}
                <div className="py-2 pb-4 type-radio_dimensions">

                    {
                        isSubcomponent ? <HeaderStep className="subheader" title={step.name} right={<><a className="pointer" onClick={(e) => {
                            e.preventDefault();
                            store.openDimensions(step.id);
                        }}>{_t("full_dimensions")}</a></>} /> : null
                    }
                    <Debugger data={step} isOpen={false} />


                    <Error visible={step.isValid === false} >{_t("select_required")}</Error>
                    <div className="d-grid g-2 grid-cols-3 grid-cols-lg-5 pb-2">
                        <AnimatePresence>

                            {
                                step.filteredOptions.map((item, index) => {
                                    return <SimpleSwitch key={item.id}
                                        product={item}
                                        data={{ id: item.id, optionId: step.id }}
                                        selectedPriceVariant={item.selectedPriceVariant}
                                        price={item.relativePrice}
                                        showPrice={true}
                                        name={item.name}
                                        checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                                        onClick={() => {
                                            store.updateSelectedDimesion(item.valueId)
                                            store.updateOption(item.optionId, item.valueId)
                                        }}
                                    />
                                })
                            }
                        </AnimatePresence>
                    </div>

                    {step.hasFilteredOptions ? (
                        <>
                            <InfoBar onClick={() => {
                                step.filterOptions(!step.areOptionsFiltered)
                            }}>
                                <RenderIf condition={step.areOptionsFiltered}>
                                    <span dangerouslySetInnerHTML={{ __html: _t("non_standard_size") }} />
                                </RenderIf>
                                <RenderIf condition={!step.areOptionsFiltered}>
                                    <u>{_t("standard_view")}</u>
                                </RenderIf>
                            </InfoBar>
                        </>
                    ) : null}

                </div>
            </>
        case 'select_headboard':

            return <>
                {!isSubcomponent ? <HeaderStep id={step.typeId} index={index} title={step.name} right={null} /> : null}
                {/* height */}
                <div className="py-2 pb-4 type-radio_height">
                    {isSubcomponent ? <HeaderStep
                        id={step.typeId}
                        title={step.name}
                        className={'subheader'}
                        right={<><a className="pointer" onClick={(e) => {
                            e.preventDefault();
                            store.openBedheadDimensions(step.id);
                        }}>{_t("how_to_choose")}</a></>} /> : null}

                    <Debugger data={step} isOpen={false} />

                    <Error visible={step.isValid === false} >{_t("select_required")}</Error>
                    <div className="d-grid g-2 grid-cols-3 grid-cols-lg-5 pb-4">
                        {
                            options?.map((item, index) => {
                                return <SimpleSwitch
                                    key={item.id}
                                    data={{ id: item.id, optionId: step.id }}
                                    name={item.name}
                                    price={item.relativePrice}
                                    showPrice={true}
                                    checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                                    onClick={() => {
                                        store.updateSelectedHeight(item.valueId)
                                        store.updateOption(item.optionId, item.valueId)
                                    }}
                                />
                            })
                        }
                    </div>

                </div>
            </>
        case 'select_headboard_width':

            return <>
                {!isSubcomponent ? <HeaderStep id={step.typeId} index={index} title={step.name} right={null} /> : null}
                {/* height */}
                <div className="py-2 pb-4 type-radio_height">
                    {isSubcomponent ? <HeaderStep
                        id={step.typeId}
                        title={step.name}
                        className={'subheader'}
                    // right={<><a className="pointer" onClick={(e) => {
                    //     e.preventDefault();
                    //     store.openBedheadDimensions(step.id);
                    // }}>{_t("how_to_choose")}</a></>} 
                    /> : null}

                    <Debugger data={step} isOpen={false} />

                    <Error visible={step.isValid === false} >{_t("select_required")}</Error>
                    <div className="d-grid g-2 grid-cols-3 grid-cols-lg-5 pb-4">
                        {
                            options?.map((item, index) => {
                                return <SimpleSwitch
                                    key={item.id}
                                    data={{ id: item.id, optionId: step.id }}
                                    name={item.label}
                                    price={item.relativePrice}
                                    showPrice={true}
                                    checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                                    onClick={() => {
                                        store.updateSelectedHeight(item.valueId)
                                        store.updateOption(item.optionId, item.valueId)
                                    }}
                                />
                            })
                        }
                    </div>

                </div>
            </>
        case 'fabric_component':

            return <>
                {/* Tkaniny */}
                <HeaderStep id={step.typeId} index={index} title={step.name} right={null} />

                <Debugger data={step} isOpen={false} />

                <Error visible={step.isValid === false} >{_t("select_required")}</Error>
                <div className="row g-0 py-2">
                    <div className="col-12 col-lg-5 col-xl-4 col-xxl-5 order-lg-1 mt-n3 mt-lg-n5">
                        <InfoBar>
                            <div className="row g-0 a-center">
                                <div className="col-12 mb-2">
                                    <span dangerouslySetInnerHTML={{ __html: _t("fabric_question") }} />

                                </div>
                                <div className="col-12">
                                    <div className="g-2 d-flex wrap nowrap-xxl a-center j-start w-100">
                                        <Button onClick={() => {
                                            store.openSwatches();

                                            Gtm.setStore(store);
                                            Gtm.push({
                                                event: "konfigurator_click",
                                                ecommerce: {
                                                    button_name: "zamów próbki tkanin",
                                                    value: Gtm.getPrice(),
                                                    items: [
                                                        {
                                                            item_name: Gtm.getProductName(),
                                                            item_id: Gtm.getProductId(),
                                                            item_brand: "MyBed",
                                                            item_category: "Łóżka",
                                                            item_variant: Gtm.getVariantStr(),
                                                        }
                                                    ]
                                                }
                                            })
                                            Clarity.push("konfigurator_click - zamów próbki tkanin");
                                        }} className="btn-sm w-100 primary">{_t("order_samples")}</Button>
                                        <Button
                                            onClick={() => {
                                                store.openVideoPopup();

                                                Gtm.setStore(store);
                                                Gtm.push({
                                                    event: "konfigurator_click",
                                                    ecommerce: {
                                                        button_name: "zobacz poradnik",
                                                        value: Gtm.getPrice(),
                                                        items: [
                                                            {
                                                                item_name: Gtm.getProductName(),
                                                                item_id: Gtm.getProductId(),
                                                                item_brand: "MyBed",
                                                                item_category: "Łóżka",
                                                                item_variant: Gtm.getVariantStr(),
                                                            }
                                                        ]
                                                    }
                                                })
                                                Clarity.push("konfigurator_click - zobacz poradnik");
                                            }}
                                            className="btn-sm w-100 primary hollow">
                                            {_t("view_guide")} <Play className="ms-2" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </InfoBar>
                    </div>
                    <div className="col-12 col-lg-7 col-xl-8 col-xxl-7">
                        <FiltersFabrics filtersStore={store.fabricFilters} />


                    </div>
                </div>

                {store.fabricCollectionFiltered.length < 1 && <InfoBar className="w-100">
                    {_t("no_results")}
                </InfoBar>}
                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 py-2 pb-5">
                    {store.fabricCollectionFiltered.map((item, index) => {
                        return <FabricCard
                            onClick={() => {
                                store.openFabricCategory(item.id);
                                // store.selectFabric(item.fabrics[0].valueId);
                                // store.updateOption(step.id, item.fabrics[0].valueId);
                            }}
                            data={{ id: item.id, optionId: step.id }}

                            imageUrl={item.filteredImageURL(store.fabricFilters.getFilterValue('colors'))}
                            checked={item.id === store.selectedFabric?.fabricCategoryId}
                            name={item.name}
                            price={item.price}
                            attributes={item.fabricFeatures.map((f) => f.name)}
                            properties={item.fabricProperties}
                            videoUrl={item.sampler_video_url}
                            key={index}
                        />
                    })}

                </div>


            </>

        case 'select_electrical_sockets':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />

                <Debugger data={{
                    canUseHalfSizeMattress: store.canUseHalfSizeMattress,
                    canUseFullSizeMattress: store.canUseFullSizeMattress,
                    step,
                }} isOpen={false} />

                <Error visible={step.isValid === false} >{_t("select_required")}</Error>

                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 grid-cols-lg-3 py-2 pb-5">
                    {step.optionsAvailable?.map((item: OptionModel, index) => {
                        return <SimpleCard
                            product={item}
                            horizontalWidth={BREAKPOINT_SM}
                            onClick={() => {
                                store.selectFrame(item.valueId);
                                store.updateOption(item.optionId, item.valueId);
                            }}
                            onMoreClick={item.learn_more ? () => {
                                // console.log('more click 1');
                                store.openFrameDescription(item);
                            } : null}
                            hasFullImage={item.imageFull}
                            onExpandClick={() => {
                                console.log('onExpand click');
                                store.openPreview(item.imageFull, 'xl');
                            }}
                            image={item.image}
                            name={item.name}
                            description={item.description}
                            price={item.price}
                            checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                            attributes={[]}
                            key={index}
                        />
                    })}
                </div>
            </>
        case 'select_frame':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />

                <Debugger data={{
                    canUseHalfSizeMattress: store.canUseHalfSizeMattress,
                    canUseFullSizeMattress: store.canUseFullSizeMattress,
                    step,
                }} isOpen={false} />

                <Error visible={step.isValid === false} >{_t("select_required")}</Error>

                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 grid-cols-lg-3 py-2 pb-5">
                    {step.optionsAvailable?.map((item: OptionModel, index) => {
                        return <SimpleCard
                            product={item}
                            horizontalWidth={BREAKPOINT_SM}
                            onClick={() => {
                                store.selectFrame(item.valueId);
                                store.updateOption(item.optionId, item.valueId);
                            }}
                            onMoreClick={item.learn_more ? () => {
                                // console.log('more click 1');
                                store.openFrameDescription(item);
                            } : null}
                            hasFullImage={item.imageFull}
                            onExpandClick={() => {
                                console.log('onExpand click');
                                store.openPreview(item.imageFull);
                            }}
                            image={item.image}
                            name={item.name}
                            description={item.description}
                            price={item.price}
                            checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                            attributes={[]}
                            key={index}
                        />
                    })}
                </div>
            </>
        case 'select_headboard':
        case 'select_headboard_type':
        case 'select_bed_side':
        case 'select_drawer_fill':
            // if there are no options available and step is not required, hide the step
            if (options?.length === 0) {
                return null;
            }
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />
                <Debugger data={step} isOpen={false} />
                <Error visible={step.isValid === false} >{_t("select_required")}</Error>
                <div className="d-grid g-2 grid-cols-2  py-2 pb-5">
                    {options?.map((item: OptionModel, index) => {
                        return <SimpleCard
                            horizontalWidth={({ width }) => width > BREAKPOINT_SM}
                            onClick={() => {
                                store.selectHeadboard(item);
                                store.updateOption(item.optionId, item.valueId);
                            }}
                            hasFullImage={item.imageFull}
                            onExpandClick={() => {
                                console.log('onExpand click');
                                store.openPreview(item.imageFull);
                            }}
                            onMoreClick={item.learn_more ? () => {

                                store.openFrameDescription(item);
                            } : null}
                            image={item.image}
                            disabled={item.isAvailable === false}
                            name={item.name}
                            price={item.price}
                            description={item.description}
                            attributes={item.attributes}
                            checked={item.valueId === store.getStepByOptionId(item.optionId)?.value}
                            key={index}
                        />
                    })}

                </div>

            </>

        case 'select_types_of_headboards':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />
                <Debugger data={step} isOpen={false} />
                <Error visible={step.isValid === false} >{_t("select_required")}</Error>

                <div className="d-grid g-2 grid-cols-2  py-2 pb-5">
                    {options?.map((item: OptionModel, index) => {
                        return <SimpleCard
                            horizontalWidth={({ width }) => width > BREAKPOINT_SM}
                            onClick={() => {
                                store.selectHeadboard(item);
                                store.updateOption(item.optionId, item.valueId);
                            }}

                            hasFullImage={item.imageFull}
                            onExpandClick={() => {
                                console.log('onExpand click');
                                store.openPreview(item.imageFull);
                            }}
                            // onMoreClick={() => {
                            //     console.log('more click 1');
                            // }}
                            price={item.price}
                            image={item.image}
                            name={item.name}
                            description={item.description}
                            attributes={item.attributes}
                            checked={item.valueId === store.getStepByOptionId(item.optionId)?.value}
                            key={index}
                        />


                    })}

                </div>
            </>
        case 'select_legs':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />
                <Debugger data={step} isOpen={false} />



                <div className="d-grid g-2 grid-cols-1 grid-cols-md-3 grid-cols-lg-4 py-2 pb-5">
                    {options?.map((item: OptionModel, index) => {
                        return <SimpleCard
                            data={{ optionId: item.optionId, valueId: item.valueId }}
                            bestseller={item.id === 1}
                            horizontalWidth={BREAKPOINT_SM}
                            onClick={() => {
                                store.selectLeg(item.valueId);
                                store.updateOption(item.optionId, item.valueId);
                            }}
                            // onMoreClick={() => {
                            //     console.log('more click 1');
                            // }}
                            hasFullImage={item.imageFull}
                            onExpandClick={() => {
                                console.log('onExpand click');
                                store.openPreview(item.imageFull);
                            }}
                            price={item.price}
                            image={item.image}
                            name={item.name}
                            description={item.description}
                            attributes={item.attributes}

                            checked={item.valueId === store.getStepByOptionId(item.optionId)?.value}
                            key={index}
                        />
                    })}
                </div>
            </>

        // 3 columns
        case 'select_opening_method':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />
                <Debugger data={step} isOpen={false} />

                <Error visible={step.isValid === false} >{_t("select_required")}</Error>

                <div className="d-grid g-2 grid-cols-1 grid-cols-md-3 grid-cols-lg-3 py-2 pb-5">
                    {options?.map((item: OptionModel, index) => {
                        return <SimpleCard
                            product={item}
                            data={{ optionId: item.optionId, valueId: item.valueId }}
                            bestseller={item.id === 1}
                            horizontalWidth={BREAKPOINT_SM}
                            onClick={() => {
                                store.updateOption(step.id, item.valueId);
                            }}
                            onMoreClick={() => {

                                if (item.learn_more) {
                                    store.openFrameDescription(item);
                                } else if (item.url) {
                                    window.open(item.url, '_blank');
                                    return;
                                }

                            }}
                            hasFullImage={item.imageFull}
                            onExpandClick={() => {
                                console.log('onExpand click');
                                store.openPreview(item.imageFull);
                            }}
                            price={item.price}
                            image={item.image}
                            name={item.name}
                            description={item.description}
                            attributes={item.attributes}

                            checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                            key={index}
                        />
                    })}

                </div>
            </>
        case 'mattress':
            return <>
                <HeaderStep id={step.typeId} index={index} title={
                    <>{step.name} <GoldBadge>W zakupie z łóżkiem -10%</GoldBadge></>
                } />

                <div className="mb-1">({_t("mattress_size")} <b>{String(store.mattresSize)}</b>)</div>
                <Debugger data={step} isOpen={false} />





                <div className="row p-1">
                    <div className="col-12 col-lg-4 order-lg-1 mt-lg-n5">
                        <InfoBar>
                            <div className="row a-center gx-0">
                                <div className="col-12 mb-2">
                                    <span dangerouslySetInnerHTML={{ __html: _t("mattress_question") }} />
                                </div>
                                <div className="col-12">
                                    <div className="g-2 d-flex a-center j-start w-100">
                                        {/* <Button onClick={() => {
                                            store.quiz.open();
                                        }} className="btn-sm w-100 primary">Rozwiąż quiz</Button> */}
                                        <Button
                                            onClick={() => {
                                                store.openComparision();
                                            }}
                                            className="btn-sm w-100 primary hollow">
                                            {_t("compare_models")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </InfoBar>
                    </div>
                    <div className="col-12 col-lg-8">
                        <div className="g-1 d-flex a-center j-start w-100 wrap">

                            {/* hasSelectedMattressMatchingFullSize */}
                            {/* hasSelectedMattressMatchingHalfSize */}

                            <SwitchSelector active={store.mattressAmount}>
                                <SwitchSelectorButton
                                    className="btn-sm"
                                    disabled={(store.hasSelectedMattressMatchingFullSize === false && store.selectedMattress.length > 0) || store.mattressFullSize.length === 0}
                                    active={store.mattressAmount === 1}
                                    onClick={e => {
                                        store.setMattressAmount(1);
                                    }}>
                                    <SingleMattressIcon className="me-1" />
                                    {_t("one_mattress")}</SwitchSelectorButton>
                                <RenderIf condition={store.hasAnyHalfSizeMattress === true || store.hasSelectedMattressMatchingHalfSize === true}>
                                    <SwitchSelectorButton
                                        className="btn-sm"
                                        disabled={(store.hasSelectedMattressMatchingHalfSize === false && store.selectedMattress.length > 0) || store.mattressHalfSize.length === 0}
                                        active={store.mattressAmount === 2}
                                        onClick={async e => {
                                            store.setMattressAmount(2);
                                        }}>
                                        <DoubleMattressIcon className="me-1" />
                                        {_t("two_single")}</SwitchSelectorButton>
                                </RenderIf>
                            </SwitchSelector>
                            <RenderIf condition={store.hasAnyHalfSizeMattress === true || store.hasSelectedMattressMatchingHalfSize === true}>

                                <a className="ms-2 py-2 text-link" onClick={() => {
                                    store.openMattressType();
                                }}>{_t("how_to_choose_q")}</a>
                            </RenderIf>
                        </div>

                    </div>
                </div>
                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 grid-cols-lg-3 py-4">
                    <BlankCard
                        checked={store.selectedMattressId < 1}
                        onClick={() => {
                            store.selectMattress({ valueId: 0 });
                            store.updateOption(step.id, 0)
                        }}
                    />
                    {
                        step.options
                            .filter((m: ProductModel) => {
                                if (store.type === 'additional_mattress') {
                                    return store.additionalSizeMattress.some(s => m.hasMatchingVariant(s.optionId, s.valueId))
                                }


                                const hasSome = store.mattressMatchingSize.some(s => m.hasMatchingVariant(s.optionId, s.valueId))
                                return hasSome
                            })
                            .filter((m: ProductModel) => {
                                // if present and set available_mattresses then only return items with those ids
                                // filter out rest of the items
                                return store.product.available_mattresses.length > 0 ? store.product.available_mattresses.some(s => m.productId === s) : true
                            })
                            .filter((m: ProductModel) => {
                                // if present and set allow_only_mattres then only return items with those ids
                                // filter out rest of the items
                                const selectedFrame = store.getStepByType('select_frame')?.selectedOption;
                                if (selectedFrame && selectedFrame.allow_only_mattres.length > 0) {

                                    return selectedFrame.allow_only_mattres.some(s => m.productId === s);
                                }
                                return true;
                            })
                            .map((item: ProductModel, index) => {
                                const selected = store.selectedMattressId === item.valueId;
                                const regularPrice = !selected ? item.price * store.mattressAmount : store.selectedMattress.reduce((acc, p) => {
                                    return acc + p.price
                                }, 0);
                                const discountedPrice = !selected ? item.discountedPrice * store.mattressAmount : store.selectedMattress.reduce((acc, p) => {
                                    return acc + p.discountedPrice
                                }, 0);
                                return <ConfigurableCard
                                    data={{ optionId: step.id, valueId: item.valueId }}
                                    key={index}
                                    product={item}
                                    onClick={() => {
                                        store.selectMattress(item);
                                        store.updateOption(step.id, item.valueId);
                                    }}
                                    onMoreClick={() => {

                                        if (item.learn_more) {
                                            store.openFrameDescription(item);
                                        } else if (item.url) {
                                            window.open(item.url, '_blank');
                                            return;
                                        }


                                        Gtm.push({
                                            event: "konfigurator_click",
                                            ecommerce: {
                                                button_name: `Dowiedz się wiecej - ${item.name}`,
                                                value: Gtm.getPrice(),
                                                items: [
                                                    {
                                                        item_name: Gtm.getProductName(),
                                                        item_id: Gtm.getProductId(),
                                                        item_brand: "MyBed",
                                                        item_category: "Łóżka",
                                                        item_variant: Gtm.getVariantStr(),
                                                    }
                                                ]
                                            }
                                        });
                                        Clarity.push(`konfigurator_click - Dowiedz się wiecej - ${item.name}`);

                                    }}
                                    bestseller={item.badgeText}
                                    image={item.image}
                                    name={item.name}
                                    description={null}
                                    // price={item.price * item.quantity}
                                    price={regularPrice}
                                    discountedPrice={discountedPrice}
                                    checked={selected}

                                    attributes2Header=""
                                    attributes2={item.attributes}
                                    attributesHeader={_t("who_for")}
                                    attributes={item.mattress_for_whom}
                                >
                                    <Debugger
                                        style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 22 }}
                                        data={{
                                            p1: store.selectedMattress.at(0)?.toOptions(),
                                            p2: store.selectedMattress.at(1)?.toOptions(),
                                        }} isOpen={false} />
                                    <>

                                        {store.selectedMattress.at(0) && item.hasConfigurationOption(MATTRESS_HARDNESS_OPTION_ID) ? (
                                            <>
                                                <div className="d-flex w-100 mt-3 mb-2">
                                                    <div className="mr-auto"><b>{_t("hardness")}</b></div>
                                                    <div>
                                                        <a href="#" onClick={e => {
                                                            e.preventDefault();
                                                            store.openHardnessPopup();
                                                        }}>{_t("how_to_choose_q")}</a>
                                                    </div>

                                                </div>
                                                <Select2 className="Select2--radius medium mb-3"
                                                    disabled={!selected}
                                                    onChange={(e, option) => {
                                                        item.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                                        var item2 = store.selectedMattress.at(0);
                                                        item2.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);

                                                    }}
                                                    value={selected ? store.selectedMattress.at(0).getOptionValue(MATTRESS_HARDNESS_OPTION_ID) : item.getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID)[0]?.id}
                                                    options={item.getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID).map(o => ({ label: o.name, value: o.id }))} />
                                            </>
                                        ) : null}
                                        {store.selectedMattress.at(1) && item.hasConfigurationOption(MATTRESS_HARDNESS_OPTION_ID) ? (
                                            <>
                                                <div className="d-flex w-100 mt-3 mb-2">
                                                    <div className="mr-auto"><b>{_t("hardness_2")}</b></div>
                                                    <div>
                                                        <a href="#" onClick={e => {
                                                            e.preventDefault();
                                                            store.openHardnessPopup();
                                                        }}>{_t("how_to_choose_q")}</a>
                                                    </div>

                                                </div>
                                                <Select2 className="Select2--radius medium mb-3"

                                                    disabled={!selected}
                                                    onChange={(e, option) => {
                                                        item.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                                        var item2 = store.selectedMattress.at(1);
                                                        item2.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                                    }}
                                                    value={selected ? store.selectedMattress.at(1).getOptionValue(MATTRESS_HARDNESS_OPTION_ID) : store.selectedMattress.at(1).getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID)[0]?.id}
                                                    options={item.getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID).map(o => ({ label: o.name, value: o.id }))}
                                                />



                                            </>

                                        ) : null}
                                    </>



                                </ConfigurableCard>
                            })}
                </div>



            </>
        case 'additional_mattress':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />
                <Debugger data={{
                    attionalMattress: store.additionalSizeMattress.map(s => ({ optionId: s.optionId, valueId: s.valueId })),
                    options: step.options.map(o => ({
                        variants: o.variants.map(v => ({ option: v.option, value: v.value }))
                    }))
                }} isOpen={false} />


                <div>({_t("mattress_size")} <b>{String(store.additionalMattresSize)}</b>)</div>
                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 grid-cols-lg-3 py-4">
                    <BlankCard
                        checked={store.selectedAdditionalMattressId < 1}
                        onClick={() => {
                            store.selectAdditionalMattress({ valueId: 0 });
                            store.updateOption(step.id, 0)
                        }}
                    />
                    {step.options.filter((m: ProductModel) => {
                        return store.additionalSizeMattress.some(s => m.hasMatchingVariant(s.optionId, s.valueId))
                    }).map((item: ProductModel, index) => {
                        const selected = store.selectedAdditionalMattressId === item.valueId;
                        const regularPrice = !selected ? item.priceForSizes(store.additionalSizeMattress) : store.selectedAdditionalMattress.reduce((acc, p) => {
                            return acc + p.price
                        }, 0);
                        const discountedPrice = item.hasMattressWithBedOption ? regularPrice * (1 - MATTRESS_WITH_BED_DISCOUNT) : regularPrice;
                        return <ConfigurableCard
                            data={{ optionId: step.id, valueId: item.valueId }}
                            key={index}
                            product={item}
                            onClick={() => {
                                store.selectAdditionalMattress(item);
                                store.updateOption(step.id, item.valueId);
                            }}
                            onMoreClick={() => {

                                if (item.learn_more) {
                                    store.openFrameDescription(item);
                                } else if (item.url) {
                                    window.open(item.url, '_blank');
                                    return;
                                }

                            }}
                            bestseller={item.badgeText}
                            image={item.image}
                            name={item.name}
                            // description={item.description}
                            // price={item.price * item.quantity}
                            price={regularPrice}
                            discountedPrice={discountedPrice}
                            checked={selected}

                            attributes2Header=""
                            attributes2={item.attributes}
                            attributesHeader={_t("who_for")}
                            attributes={item.mattress_for_whom}
                        >
                            <Debugger
                                style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 22 }}
                                data={{
                                    p1: store.selectedAdditionalMattress.at(0)?.toOptions(),
                                    p2: store.selectedAdditionalMattress.at(1)?.toOptions(),
                                }} isOpen={false} />
                            <>

                                {store.selectedAdditionalMattress.at(0) && item.hasConfigurationOption(MATTRESS_HARDNESS_OPTION_ID) ? (
                                    <>
                                        <div className="d-flex w-100 mt-3 mb-2">
                                            <div className="mr-auto"><b>{_t("hardness")}</b></div>
                                            <div>
                                                <a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    store.openHardnessPopup();
                                                }}>{_t("how_to_choose_q")}</a>
                                            </div>

                                        </div>
                                        <Select2 className="Select2--radius medium mb-3"
                                            disabled={!selected}
                                            onChange={(e, option) => {
                                                item.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                                var item2 = store.selectedAdditionalMattress.at(0);
                                                item2.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);

                                            }}
                                            value={store.selectedAdditionalMattress.at(0).getOptionValue(MATTRESS_HARDNESS_OPTION_ID)}
                                            options={store.selectedAdditionalMattress.at(0).getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID).map(o => ({ label: o.name, value: o.id }))} />
                                    </>
                                ) : null}
                                {store.selectedAdditionalMattress.at(1) && item.hasConfigurationOption(MATTRESS_HARDNESS_OPTION_ID) ? (
                                    <>
                                        <div className="d-flex w-100 mt-3 mb-2">
                                            <div className="mr-auto"><b>{_t("hardness_2")}</b></div>
                                            <div>
                                                <a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    store.openHardnessPopup();
                                                }}>{_t("how_to_choose_q")}</a>
                                            </div>

                                        </div>
                                        <Select2 className="Select2--radius medium mb-3"

                                            disabled={!selected}
                                            onChange={(e, option) => {
                                                item.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                                var item2 = store.selectedAdditionalMattress.at(1);
                                                item2.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                            }}
                                            value={store.selectedAdditionalMattress.at(1).getOptionValue(MATTRESS_HARDNESS_OPTION_ID)}
                                            options={store.selectedAdditionalMattress.at(1).getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID).map(o => ({ label: o.name, value: o.id }))}
                                        />



                                    </>

                                ) : null}
                            </>



                        </ConfigurableCard>
                    })}
                </div>



            </>
        case 'mattress_toppers':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />
                <Debugger data={step} isOpen={false} />





                <div className="row p-1">

                    {/* <div className="col-12 col-lg-7">
                        <div className="g-1 d-flex a-center j-start w-100 wrap">

                            <SwitchSelector active={store.mattressAmount}>
                                <SwitchSelectorButton
                                    className="btn-sm"
                                    active={store.mattressAmount === 1}
                                    onClick={e => {
                                        store.setMattressAmount(1);
                                    }}>
                                    <SingleMattressIcon className="me-2" />
                                    Jeden materac</SwitchSelectorButton>
                                <SwitchSelectorButton
                                    className="btn-sm"
                                    active={store.mattressAmount === 2}
                                    onClick={async e => {
                                        store.setMattressAmount(2);
                                    }}>
                                    <DoubleMattressIcon className="me-2" />
                                    Dwa pojedyncze</SwitchSelectorButton>
                            </SwitchSelector>
                            <a className="ms-2 text-link" onClick={() => {
                                store.openMattressType();
                            }}>{_t("how_to_choose_q")}</a>
                        </div>

                    </div> */}
                </div>
                <div>({_t("mattress_size")} <b>{String(store.mattresSize)}</b>)</div>
                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 grid-cols-lg-4 py-4">
                    <BlankCard
                        checked={store.selectedTopMattressId < 1}
                        onClick={() => {
                            store.selectTopMattress({ valueId: 0 });
                            store.updateOption(step.id, 0)
                        }}
                    />
                    {step.options.filter(m => {
                        return store.mattressMatchingSize.length > 0;
                    }).map((item: ProductModel, index) => {
                        const selected = store.selectedTopMattressId === item.valueId;
                        const regularPrice = !selected ? item.price : store.selectedTopMattress.reduce((acc, p) => {
                            return acc + p.price
                        }, 0);
                        const discountedPrice = item.hasMattressWithBedOption ? regularPrice * (1 - MATTRESS_WITH_BED_DISCOUNT) : regularPrice;
                        return <ConfigurableCard
                            priceWrap={true}
                            data={{ optionId: step.id, valueId: item.valueId }}
                            key={index}
                            product={item}
                            onClick={() => {
                                store.selectTopMattress(item);
                                store.updateOption(step.id, item.valueId);
                            }}
                            onMoreClick={() => {
                                if (item.learn_more) {
                                    store.openFrameDescription(item);
                                } else if (item.url) {
                                    window.open(item.url, '_blank');
                                    return;
                                }

                            }}
                            bestseller={item.badgeText}
                            image={item.image}
                            name={item.name}
                            // description={item.description}
                            // price={item.price * item.quantity}
                            price={regularPrice}
                            discountedPrice={discountedPrice}
                            checked={selected}


                            attributes2Header=""
                            attributes2={item.attributes}
                            attributesHeader={_t("who_for")}
                            attributes={item.mattress_for_whom}
                        >
                            <Debugger
                                style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 22 }}
                                data={{
                                    p1: store.selectedTopMattress.at(0)?.toOptions(),
                                    p2: store.selectedTopMattress.at(1)?.toOptions(),
                                }} isOpen={false} />
                            <>

                                {store.selectedTopMattress.at(0) && item.hasConfigurationOption(MATTRESS_HARDNESS_OPTION_ID) ? (
                                    <>
                                        <div className="d-flex w-100 mt-3 mb-2">
                                            <div className="mr-auto"><b>{_t("hardness")}</b></div>
                                            <div>
                                                <a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    store.openHardnessPopup();
                                                }}>{_t("how_to_choose_q")}</a>
                                            </div>

                                        </div>
                                        <Select2 className="Select2--radius medium mb-3"
                                            disabled={!selected}
                                            onChange={(e, option) => {
                                                item.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                                var item2 = store.selectedTopMattress.at(0);
                                                item2.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);

                                            }}
                                            value={store.selectedTopMattress.at(0).getOptionValue(MATTRESS_HARDNESS_OPTION_ID)}
                                            options={store.selectedTopMattress.at(0).getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID).map(o => ({ label: o.name, value: o.id }))} />
                                    </>
                                ) : null}
                                {store.selectedTopMattress.at(1) && item.hasConfigurationOption(MATTRESS_HARDNESS_OPTION_ID) ? (
                                    <>
                                        <div className="d-flex w-100 mt-3 mb-2">
                                            <div className="mr-auto"><b>{_t("hardness_2")}</b></div>
                                            <div>
                                                <a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    store.openHardnessPopup();
                                                }}>{_t("how_to_choose_q")}</a>
                                            </div>

                                        </div>
                                        <Select2 className="Select2--radius medium mb-3"

                                            disabled={!selected}
                                            onChange={(e, option) => {
                                                item.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                                var item2 = store.selectedTopMattress.at(1);
                                                item2.updateOption(MATTRESS_HARDNESS_OPTION_ID, option.value);
                                            }}
                                            value={store.selectedTopMattress.at(1).getOptionValue(MATTRESS_HARDNESS_OPTION_ID)}
                                            options={store.selectedTopMattress.at(1).getOptionsByOptionId(MATTRESS_HARDNESS_OPTION_ID).map(o => ({ label: o.name, value: o.id }))}
                                        />



                                    </>

                                ) : null}
                            </>



                        </ConfigurableCard>
                    })}
                </div>



            </>

        case 'select_built-in_mattress':
            return <>
                {!isSubcomponent ? <HeaderStep id={step.type} index={index} title={step.name} right={null} /> : null}
                <Debugger data={step} isOpen={false} />

                {/* Materac nawierzchniowy */}
                {/* <div>({_t("mattress_size")} <b>{store.mattresSize}</b>)</div> */}

                <Error visible={step.isValid === false} >{_t("select_required")}</Error>
                <div className="d-grid g-2 grid-cols-1 grid-cols-md-3 grid-cols-lg-4 py-2 pb-5">

                    {/* <BlankCard

                        checked={store.selectedTopMattressId < 1}
                        onClick={() => {
                            store.selectTopMattress({ valueId: 0 });
                            store.updateOption(step.id, 0)
                        }} /> */}

                    {step.options.map((item: OptionModel, index) => {
                        return <SimpleCard
                            product={item}
                            bestseller={item.badgeText}
                            horizontalWidth={BREAKPOINT_SM}
                            onClick={() => {
                                // store.selectTopMattress(item);
                                store.updateOption(step.id, item.valueId)
                            }}
                            // onMoreClick={() => {
                            //     console.log('more click 1');
                            // }}
                            hasFullImage={item.imageFull}
                            onExpandClick={() => {
                                console.log('onExpand click');
                                store.openPreview(item.imageFull);
                            }}
                            price={item.price}
                            image={item.image}
                            name={item.name}
                            description={item.description}
                            attributes={item.attributes}


                            checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                            key={index}
                        />
                    })}
                </div>



            </>
        case 'select_built-in_mattress_hardness': // build in mattress hardness
            return <>

                {!isSubcomponent ? <HeaderStep id={step.typeId} index={index} title={step.name} right={null} /> : null}
                <Debugger data={step} isOpen={false} />



                {options?.length > 1 ? (
                    <div className="py-2 pb-4">
                        {
                            isSubcomponent ? <HeaderStep id={step.typeId} className="subheader" title={step.name} right={<>


                                <a href="#" onClick={e => {
                                    e.preventDefault();
                                    store.openHardnessPopup();
                                }}>{_t("how_to_choose_q")}</a>

                            </>} /> : null
                        }
                        <Error visible={step.isValid === false} >{_t("select_required")}</Error>

                        <div className="type-default py-1">
                            <Debugger data={step} isOpen={false} />

                            <div className="d-grid g-2 grid-cols-3 grid-cols-lg-5 pb-4">
                                {
                                    options?.map((item, index) => {
                                        return <SimpleSwitch
                                            option={item}
                                            item={item}
                                            key={item.id}
                                            data={{ valueId: item.valueId, optionId: step.id }}
                                            name={item.name}
                                            price={null}
                                            attributes={item.attributes}
                                            disabled={item.isAvailable === false}
                                            checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                                            onClick={() => {
                                                store.updateOption(step.id, item.valueId)
                                            }}
                                        />
                                    })
                                }
                            </div>


                        </div>
                    </div>
                ) : null}


            </>

        case 'select_safety_type':
            return <>
                <HeaderStep id={step.typeId} index={index} title={step.name} />
                <Debugger data={step} isOpen={false} />

                <Error visible={step.isValid === false} >{_t("select_required")}</Error>

                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 grid-cols-lg-3 py-4">
                    <BlankCard

                        checked={store.selectedSafetyProductIds.length === 0}
                        onClick={() => {
                            store.clearSafetyProducts();
                            store.updateOption(step.id, []);
                        }}
                    >{_t("continue_without_safety")}</BlankCard>
                    {step.options.filter(o => o.can_buy).map((item: OptionModel | ProdcutModel, index) => {
                        const selected = store.selectedSafetyProductIds.includes(item.valueId);
                        return <ConfigurableCard
                            priceWrap={false}
                            data={{ optionId: step.id, valueId: item.valueId }}
                            key={index}
                            product={item}
                            onClick={() => {
                                store.toggleSafetyProduct(item);
                                store.updateOption(step.id, [...store.selectedSafetyProductIds]);
                            }}
                            onMoreClick={item.learn_more ? () => {
                                if (item.learn_more) {
                                    store.openFrameDescription(item);
                                } else if (item.url) {
                                    window.open(item.url, '_blank');
                                    return;
                                }
                            } : null}
                            bestseller={item.badgeText}
                            image={item.image}
                            name={item.name}
                            price={item.price}
                            checked={selected}
                            attributes2Header=""
                            attributes2={item.attributes}
                        >
                            <div className="">
                                {item.subtitle}
                            </div>
                            {item.options_configuration?.length > 0 ? (
                                item.options_configuration.map((confOption) => (
                                    <div key={confOption.id} className="d-flex w-100 mt-3 mb-2">
                                        {/* <div className="mr-auto"><b>{confOption.name}</b></div> */}
                                        <Select2 className="Select2--radius medium"
                                            placeholder={confOption.name}
                                            // disabled={!selected}
                                            renderDisplayed={(option) => `${_t('size')}: ${option.label}`}
                                            onChange={(e, option) => {
                                                if (store.selectedSafetyProductIds.includes(item.valueId) === false) {
                                                    store.toggleSafetyProduct(item);
                                                    store.updateOption(step.id, [...store.selectedSafetyProductIds]);
                                                }

                                                item.updateOption(confOption.id, option.value);
                                            }}
                                            value={item.getOptionValue(confOption.id)}
                                            options={confOption.options.map(o => ({
                                                label: o.name,
                                                value: o.id
                                            }))} />
                                    </div>
                                ))
                            ) : (
                                <div className="d-flex w-100 mt-3 mb-2">
                                    <Select2 className="Select2--radius medium"
                                        disabled={true}
                                        placeholder={_t('fixed_size')}
                                        value={null}
                                        options={[]} />
                                </div>
                            )}
                        </ConfigurableCard>
                    })}
                </div>
            </>

        default:
            return <>
                {!isSubcomponent ? <HeaderStep id={step.typeId} index={index} title={step.name} right={null} /> : null}

                {
                    step.components?.map((component, index2) => {
                        return <ComponentTypeFactory
                            key={index2}
                            index={index}
                            step={component}
                            order={component.order}
                            componentType={component.type}
                            options={component?.optionsAvailable}
                            isSubcomponent={true}
                        />
                    })
                }

                {options?.length > 1 ? (
                    <div className="py-2 pb-4">
                        {
                            isSubcomponent ? <HeaderStep id={step.typeId} className="subheader" title={step.name} right={null} /> : null
                        }
                        <Error visible={step.isValid === false} >{_t("select_required")}</Error>

                        <div className="type-default py-1">
                            <Debugger data={step} isOpen={false} />

                            <div className="d-grid g-2 grid-cols-3 grid-cols-lg-5 pb-4">
                                {
                                    options?.map((item, index) => {
                                        return <SimpleSwitch
                                            option={item}
                                            item={item}
                                            key={item.id}
                                            data={{ valueId: item.valueId, optionId: step.id }}
                                            name={item.name}
                                            price={item.price}
                                            attributes={item.attributes}
                                            disabled={item.isAvailable === false}
                                            checked={item.valueId === store.getStepByOptionId(step.id)?.value}
                                            onClick={() => {
                                                store.updateOption(step.id, item.valueId)
                                            }}
                                        />
                                    })
                                }
                            </div>


                        </div>
                    </div>
                ) : null}
            </>
    }
})
ComponentTypeFactory.displayName = 'ComponentTypeFactory'

const Controls = observer(props => {
    const [mAmountIndex, setMAmountIndex] = React.useState(0);
    const target = useRef(null);
    // const [iobserver, setIObserver] = useState(null);
    useEffect(() => {
        const callback = (entries) => {
            // console.log(entries);
            entries.forEach(entry => {
                const step = entry.target.id && store.sortedStepsFlat.find((step) => step.typeId === entry.target.id);
                if (step) {
                    // store.steps.get(entry.target.id).active = entry.isIntersecting;
                    if (step) {
                        step.active = entry.isIntersecting;
                    }
                }
            });
        };

        let _iobserver: IntersectionObserver = null;

        if (target.current) {
            const scrollable = document.querySelector('.grid-controls');
            var headers = document.querySelectorAll('.HeaderStep[id]');
            _iobserver = new IntersectionObserver(callback, {
                threshold: 0.5,
                rootMargin: '1000% 0px -50% 0px',
                root: scrollable
            });
            headers.forEach(header => {
                _iobserver.observe(header);
            });
        }

        return () => {
            _iobserver?.disconnect();
        };
    }, [target.current]);


    return <div ref={target} className="Controls-layer  pb-6">

        <div className="creators-controls">

            <Debugger title="Cart state" data={{
                p: store.product?.options_configuration?.map(option => ({
                    name: option.step?.name,
                    option_id: option.id,
                    value: option.value
                })),
                steps: store.sortedSteps.map(step => ({
                    option_id: step.id,
                    value: step.value,
                    name: step.name,
                    components: step.components?.map(component => ({
                        option_id: component.id,
                        value: component.value,
                        name: component.name
                    }))
                })),

            }} isOpen={false} />

            {
                store.sortedSteps.map((step, index) => {
                    return <div key={index}>

                        {/* <HeaderStep index={index} title={step.name} right={step.right} /> */}
                        <ComponentTypeFactory
                            order={step.order}
                            index={index}
                            step={step}
                            options={step.optionsAvailable}
                            componentType={step.type} />
                        {/* {
                            step.components?.map((component, index) => {
                                return <>
                                    <Debugger key={index} data={component} />


                                </>
                            })
                        } */}
                    </div>
                })
            }




            <div className="my-4">
                <div className="c-h1"><b>{_t("done_your_config")}</b></div>
                <div className="w-100 w-md-75 w-xxl-50">

                    <Collapse className='Collapse--gray'
                        onOpen={() => {

                            Gtm.push({
                                event: "konfigurator_click",
                                ecommerce: {
                                    button_name: 'zobacz podsumowanie wybranych opcji',
                                    value: Gtm.getPrice(),
                                    items: [
                                        {
                                            item_name: Gtm.getProductName(),
                                            item_id: Gtm.getProductId(),
                                            item_brand: "MyBed",
                                            item_category: "Łóżka",
                                            item_variant: Gtm.getVariantStr(),
                                        }
                                    ]
                                }
                            });
                            Clarity.push("konfigurator_click - zobacz podsumowanie wybranych opcji");
                        }}
                        title={({ open }) => {
                            return <div className="d-flex a-center w-100 py-1">
                                <BedIcon className="me-2" />
                                {_t("view_summary")}
                                <div className="d-flex j-end a-center ms-1">

                                    <svg className='Collapse__arrow' width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.3078 0.999867L6 6.30762L0.692249 0.999867L1.4 0.292117L6 4.89212L10.6 0.292117L11.3078 0.999867Z" fill="#1F1F1F" />
                                    </svg>

                                </div>
                            </div>
                        }}>
                        <SummaryRender showButtons={true} />
                    </Collapse>
                </div>

            </div>



        </div>

    </div >


})


export default Controls